module.exports = __webpack_public_path__ + "img/banner.e0d4b46f.jpg";